import React, { memo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { AiProcessExecutionStatus, AiProcessStepExecutionStatus } from 'constants/aiProcessRuns';

import { STATUS_LABELS, STATUS_TO_TONE } from './StatusPill.constants';
import { getChipStyles } from './StatusPill.styles';

const StatusPill = ({ status, label: labelOverride }) => {
  const tone = STATUS_TO_TONE[status];
  const label = labelOverride ?? STATUS_LABELS[status] ?? status ?? 'Unknown';

  return <Box sx={getChipStyles(tone)}>{label}</Box>;
};

StatusPill.propTypes = {
  status: PropTypes.oneOf([
    ...Object.values(AiProcessExecutionStatus),
    ...Object.values(AiProcessStepExecutionStatus),
  ]),
  label: PropTypes.string,
};

export default memo(StatusPill);
